import React, { useEffect, useMemo, useState } from 'react';
import { Box, Drawer, List, ListItem, Typography, Divider, Toolbar, Collapse } from '@mui/material';
import {
  LayoutDashboard,
  Slack,
  CalendarHeart,
  BookText,
  FolderClock,
  AlarmClockPlus,
  ClockAlert,
  Mail,
BanknoteArrowUp,
  Shredder,
  Pencil,
  Component,
  MessageCircleWarning,
  ShieldUser,
  PackageOpen,
  Gauge,
  BotMessageSquare,
  Calendar,
  Target,
  Wallet,
  AlarmClock,
  FileChartColumn,
  FileSpreadsheet,
  Settings,
  Database,
  FolderOpen,
  CloudDownload,
  Rocket,
  Tablet,
  HandPlatter,
  ContactRound,
  Hotel,
  ChevronDown,
  ChevronRight,
  HouseHeart,
  Crown,
UserStar,
NotebookTabs,
ClipboardCheck,
  Server,
  Wrench
} from 'lucide-react';


const drawerWidth = 200;

/**
 * ✅ Menu organizado em "abas" (submenus):
 * - Dashboard: Dashboard, Smart Daily, Request Off, Guides, EmployeeSalaryHistory (+ Clock In/Out pra role 5)
 * - Sales: Sales, Deleted Sales, Edit Requests, Square, Envelope
 * - Management: Warnings, Supervisor, Material
 * - Admin: Reports, Mini Bot, Schedule, Metas, Payouts, Salary History, Clocks, Invoice
 *   + Setup (Devices, Services, Employees, Resorts)
 *   + System (Sheets, Settings, Database, File Manager, Download, Upload)
 */
const menuItems = [
  {
    text: 'Home',
    roles: [1, 2, 3, 4, 5],
    icon: <HouseHeart size={18} />,
    children: [
      { text: 'Dashboard', path: '/', roles: [1, 2, 3, 4, 5], icon: <LayoutDashboard size={16} /> },
      { text: 'Pending Sales', path: '/pending', roles: [1, 2, 3, 4, 5], icon: <ClockAlert size={16} /> },
      { text: 'Smart Daily', path: '/smartdaily', roles: [1, 2, 3, 4], icon: <Slack size={16} /> },
      { text: 'Request Off', path: '/requests', roles: [1, 2, 3, 4], icon: <CalendarHeart size={16} /> },
      { text: 'Guides', path: '/guide', roles: [1, 2, 3, 4, 5], icon: <BookText size={16} /> },
      { text: 'Salary History', path: '/employeesalaryhistory', roles: [1, 2, 4, 5], icon: <FolderClock size={16} /> },
      { text: 'Clock In/Out', path: '/clockinout', roles: [5, 3], icon: <AlarmClockPlus size={16} /> },
    ],
  },

  {
    text: 'Transactions',
    roles: [2, 3],
    icon: <BanknoteArrowUp size={18} />,
    children: [
      { text: 'Sales List', path: '/sales', roles: [2, 3], icon: <NotebookTabs size={16} /> },
      { text: 'Deleted Sales', path: '/delsales', roles: [2, 3], icon: <Shredder size={16} /> },
      { text: 'Edit Requests', path: '/editpage', roles: [2, 3], icon: <Pencil size={16} /> },
      { text: 'Square', path: '/square', roles: [2, 3], icon: <Component size={16} /> },
      { text: 'Envelope', path: '/checkup', roles: [2, 3], icon: <Mail size={16} /> },
   { text: 'Invoice', path: '/invoice', roles: [3], icon: <FileChartColumn size={16} /> },
    ],
  },

  {
    text: 'Management',
    roles: [2, 3, 4, 5],
    icon: <ShieldUser size={18} />,
    children: [
      { text: 'Warnings', path: '/warningpage', roles: [2, 3, 4], icon: <MessageCircleWarning size={16} /> },
      { text: 'Supervisor', path: '/groups', roles: [2, 3, 4], icon: <UserStar size={16} /> },
      { text: 'Material', path: '/material', roles: [2, 3, 4, 5], icon: <PackageOpen size={16} /> },
    ],
  },

  {
    text: 'Admin',
    roles: [2, 3],
    icon: <Crown size={18} />,
    children: [
       { text: 'Mini Bot', path: '/minibot', roles: [3], icon: <BotMessageSquare size={16} /> },
      { text: 'Reports', path: '/reports', roles: [2, 3], icon: <Gauge size={16} /> },
     
      { text: 'Schedule', path: '/schedule', roles: [2, 3], icon: <Calendar size={16} /> },
      { text: 'Metas', path: '/metas', roles: [2, 3], icon: <Target size={16} /> },
      { text: 'Payouts', path: '/payouts', roles: [3], icon: <Wallet size={16} /> },
      { text: 'Salary History', path: '/salaryhistory', roles: [3], icon: <FileChartColumn size={16} /> },
      { text: 'Clocks', path: '/clocks', roles: [2, 3], icon: <AlarmClock size={16} /> },
      { text: 'Checklists', path: '/closingchecklists', roles: [2, 3], icon: <ClipboardCheck size={16} /> },
    ],
  },
  {
  text: 'Setup',
  roles: [3],
  icon: <Wrench size={18} />,
  children: [
    { text: 'Devices', path: '/devices', roles: [3], icon: <Tablet size={16} /> },
    { text: 'Services', path: '/services', roles: [3], icon: <HandPlatter size={16} /> },
    { text: 'Employees', path: '/employees', roles: [3], icon: <ContactRound size={16} /> },
    { text: 'Resorts', path: '/resorts', roles: [3], icon: <Hotel size={16} /> },
  ],
},

  {
  text: 'System',
  roles: [3],
  icon: <Server size={18} />,
  children: [
    { text: 'Sheets', path: '/sheets', roles: [3], icon: <FileSpreadsheet size={16} /> },
    { text: 'Database', path: '/database', roles: [3], icon: <Database size={16} /> },
    { text: 'File Manager', path: '/cloud', roles: [3], icon: <FolderOpen size={16} /> },
    {
      text: 'Download',
      path: 'https://miniboss-backend.onrender.com/app-download/app-release.apk',
      roles: [1, 2, 3, 4, 5],
      icon: <CloudDownload size={16} />,
      external: true
    },
    { text: 'Upload', path: '/upload', roles: [3], icon: <Rocket size={16} /> },
    { text: 'Settings', path: '/settings', roles: [3], icon: <Settings size={16} /> },
  ],
},

];

// Helpers
const hasRole = (item, roleId) => item?.roles?.includes(roleId);

const isAnyChildAllowed = (item, roleId) =>
  Array.isArray(item.children) && item.children.some((c) => isAllowed(c, roleId));

const isAllowed = (item, roleId) => {
  if (item.type === 'divider') return true;
  if (hasRole(item, roleId)) return true;
  if (isAnyChildAllowed(item, roleId)) return true;
  return false;
};

const isAnyChildSelected = (item, pathname) =>
  Array.isArray(item.children) && item.children.some((c) => {
    if (c.children) return isAnyChildSelected(c, pathname);
    return c.path === pathname;
  });

export const NavigationMenu = ({
  user,
  location,
  navigate,
  isMobile,
  mobileOpen,
  toggleDrawer,
  setMobileOpen,
  showPendingSales
}) => {
  const roleId = user?.role_id;

  const [openMenus, setOpenMenus] = useState({});

  // Auto-abrir qualquer submenu que contenha a rota atual
  const autoOpenKeys = useMemo(() => {
    const keys = {};

    const walk = (items) => {
      items.forEach((it) => {
        if (it.children && it.text && isAnyChildSelected(it, location.pathname)) {
          keys[it.text] = true;
          walk(it.children);
        }
      });
    };

    walk(menuItems);
    return keys;
  }, [location.pathname]);

  useEffect(() => {
    setOpenMenus((prev) => ({ ...prev, ...autoOpenKeys }));
  }, [autoOpenKeys]);

  const toggleSubmenu = (key) => {
    setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const baseItemSx = (isSelected) => ({
    mx: 1,
    my: 0.5,
    px: 2,
    py: 1.2,
    borderRadius: 2,
    fontWeight: 'bold',
    color: isSelected ? 'rgb(50, 50, 50)' : 'rgb(90, 90, 90)',
    backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
    transition: 'all 0.2s ease-in-out',
    boxShadow: isSelected ? '0 1px 6px rgba(0,0,0,0.15)' : 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      color: 'rgb(30, 30, 30)',
      transform: 'translateX(3px)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
    }
  });

  const childItemSx = (isSelected) => ({
    mx: 1,
    my: 0.25,
    px: 2,
    py: 0.95,
    borderRadius: 2,
    fontWeight: 600,
    color: isSelected ? 'rgb(50, 50, 50)' : 'rgb(105, 105, 105)',
    backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
    transition: 'all 0.2s ease-in-out',
    boxShadow: isSelected ? '0 1px 6px rgba(0,0,0,0.12)' : 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      color: 'rgb(30, 30, 30)',
      transform: 'translateX(3px)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
    }
  });

  const renderItem = (item, index, level = 0) => {
    if (!isAllowed(item, roleId)) return null;
    // Pending Sales fica escondida até o admin ligar em Settings (`pending_sales_page`).
    if (item.path === '/pending' && !showPendingSales) return null;

    // External link
    if (item.external) {
      return (
        <ListItem
          component="a"
          href={item.path}
          key={item.text || `ext-${index}`}
          download
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            ...childItemSx(false),
            ml: level ? 1 : 0,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {item.icon}
            <Typography variant="body2">{item.text}</Typography>
          </Box>
        </ListItem>
      );
    }

    // Submenu
    if (item.children && item.children.length) {
      const parentSelected = isAnyChildSelected(item, location.pathname);
      const isOpen = !!openMenus[item.text];

      return (
        <Box key={item.text || `submenu-${index}`}>
          <ListItem
            onClick={() => toggleSubmenu(item.text)}
            sx={{
              ...(level === 0 ? baseItemSx(parentSelected) : childItemSx(parentSelected)),
              ...(level ? { ml: 1 } : {}),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              {item.icon}
              <Typography variant={level === 0 ? 'body1' : 'body2'} sx={{ flex: 1 }}>
                {item.text}
              </Typography>
              {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </Box>
          </ListItem>

          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List disablePadding sx={{ pl: level === 0 ? 1 : 2 }}>
              {item.children.map((child, childIndex) => renderItem(child, childIndex, level + 1))}
            </List>
          </Collapse>
        </Box>
      );
    }

    // Normal item
    const isSelected = location.pathname === item.path;

    return (
      <ListItem
        key={item.text || `item-${index}`}
        selected={isSelected}
        onClick={() => {
          navigate(item.path);
          if (isMobile) setMobileOpen(false);
        }}
        sx={{
          ...(level === 0 ? baseItemSx(isSelected) : childItemSx(isSelected)),
          ...(level ? { ml: 1 } : {}),
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {item.icon}
          <Typography variant={level === 0 ? 'body1' : 'body2'}>{item.text}</Typography>
        </Box>
      </ListItem>
    );
  };

  const drawerContent = (
    <Box sx={{ width: drawerWidth }}>
      <Toolbar />
      <Divider />
      <List>
        {menuItems.map((item, idx) => renderItem(item, idx))}
      </List>
    </Box>
  );

  return (
    <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: 'rgb(127, 127, 127)',
            overflowX: 'hidden'
          }
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};
